import {Box, Stack, Typography} from '@mui/material';

type HeatLegendProps = {
  scale: readonly string[];
};

export const HeatLegend = ({scale}: HeatLegendProps) => (
  <Stack
    aria-hidden
    direction="row"
    alignItems="center"
    justifyContent="flex-end"
    spacing={0.5}
    sx={{mt: 1.5}}
  >
    <Typography
      sx={theme => ({
        ...theme.tokens.text.metadata,
        color: 'text.secondary',
        mr: 0.5,
      })}
    >
      Less
    </Typography>
    {scale.map((color, index) => (
      <Box
        key={`${index}-${color}`}
        sx={theme => ({
          width: 12,
          height: 12,
          borderRadius: `${theme.tokens.radius.sm}px`,
          bgcolor: color,
        })}
      />
    ))}
    <Typography
      sx={theme => ({
        ...theme.tokens.text.metadata,
        color: 'text.secondary',
        ml: 0.5,
      })}
    >
      More
    </Typography>
  </Stack>
);
